"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityCalculationOrigin = exports.EventType = exports.AssociationsChangedType = void 0;
var AssociationsChangedType;
(function (AssociationsChangedType) {
    AssociationsChangedType["way_point"] = "way_point";
    AssociationsChangedType["task_inventory"] = "task_inventory";
    AssociationsChangedType["form"] = "form";
    AssociationsChangedType["task_note"] = "task_note";
    AssociationsChangedType["task_photo"] = "task_photo";
    AssociationsChangedType["signature"] = "signature";
})(AssociationsChangedType || (exports.AssociationsChangedType = AssociationsChangedType = {}));
var EventType;
(function (EventType) {
    EventType["ApplicationActionRun"] = "application:action:run";
    EventType["UserPreLeftHome"] = "user:pre_left_home";
    EventType["UserPreGotHome"] = "user:pre_got_home";
    EventType["UserTypeChanged"] = "user_type_changed";
    EventType["TaskCashoutCreated"] = "task:cashout:created";
    EventType["EmployeeUpdateLocation"] = "employee:update_location";
    EventType["EmployeeUpdate"] = "employee:update";
    EventType["TaskNew"] = "task:new";
    EventType["TaskAcknowledged"] = "task:acknowledged";
    EventType["TaskPaymentHistoryCreated"] = "task_payment_history:created";
    EventType["UserRated"] = "user:rated";
    EventType["CustomerTipped"] = "customer:tipped";
    EventType["CustomerCreated"] = "customer:created";
    EventType["CustomerOptedIn"] = "customer:opted_in";
    EventType["CustomerOptedOut"] = "customer:opted_out";
    EventType["CustomerAvailabilityHoursCreated"] = "customer:availability_hours:created";
    EventType["EmployeeTurnsOffline"] = "employee_turns_offline";
    EventType["EmployeeTurnsOnline"] = "employee_turns_online";
    EventType["ShiftStarted"] = "shift:started";
    EventType["ShiftEnded"] = "shift:ended";
    EventType["TaskWayPointAdded"] = "task:way_point:added";
    EventType["TaskChangePreparation"] = "task:change_preparation";
    EventType["TaskPreparationChanged"] = "task:preparation_changed";
    EventType["TaskStatusChanged"] = "task:status_changed";
    EventType["TaskDeleted"] = "task:deleted";
    EventType["TaskUpdate"] = "task:update";
    EventType["TaskPackagesChanged"] = "task:packages_changed";
    EventType["TeamUserAdded"] = "team:user_added";
    EventType["UserNew"] = "user:new";
    EventType["TeamUserRemoved"] = "team:user_removed";
    EventType["TeamTaskAdded"] = "team:task_added";
    EventType["TeamTaskRemoved"] = "team:task_removed";
    EventType["TaskCreated"] = "task:created";
    EventType["TaskCreatedFinal"] = "task:created:final";
    EventType["TaskCreatedFinalProcessingDone"] = "task:created:final:processing:done";
    EventType["TaskRemoved"] = "task:removed";
    EventType["TaskRejected"] = "task:rejected";
    EventType["UserGotHome"] = "user:got_home";
    EventType["UserLeftHome"] = "user:left_home";
    EventType["TaskLate"] = "task:late";
    EventType["AppAdded"] = "app:added";
    EventType["AppRemoved"] = "app:removed";
    EventType["RequestPush"] = "request_push";
    EventType["UsersReadyToExecute"] = "users:ready_to_execute";
    EventType["UserReadyToExecute"] = "user:ready_to_execute";
    EventType["RequestOptimizeRoute"] = "request_optimize_route";
    EventType["RequestRecalculateEta"] = "request_recalculate_eta";
    EventType["RequestOptimizeDriverRoute"] = "request_optimize_driver_route";
    EventType["RequestRescheduleCancelledTask"] = "request_reschedule_cancelled_task";
    EventType["SharedLocationCreated"] = "shared_location:created";
    EventType["MerchantCreated"] = "merchant_created";
    EventType["UserActivityChange"] = "user_activity_change";
    EventType["FormCreated"] = "form_created";
    EventType["NoteCreated"] = "note_created";
    EventType["FloatingInventoryUpdated"] = "floating_inventory:updated";
    EventType["WayPointUpdated"] = "way_point:updated";
    EventType["WayPointStarted"] = "way_point:started";
    EventType["WayPointArrived"] = "way_point:checkin";
    EventType["WayPointLeft"] = "way_point:checkout";
    EventType["MassWayPointLeft"] = "mass:way_point:checkout";
    EventType["WayPointOnTheWayProcessingDone"] = "way_point:on_the_way:processing:done";
    EventType["TaskWayPointsDoneProcessingDone"] = "task:way_points:done:processing:done";
    EventType["TaskProcessingDone"] = "task:processing:done";
    EventType["WayPointRecalculateDistance"] = "way_point:recalculate_distance";
    EventType["RecalculateDistance"] = "recalculate_distance";
    EventType["TaskReadyToExecute"] = "task:ready_to_execute";
    EventType["TeamUpdate"] = "team:update";
    EventType["MerchantConfigurationUpdated"] = "merchant:configuration_updated";
    EventType["RouteOptimized"] = "route:optimized";
    EventType["RouteOptimizationProgress"] = "route:optimization:progress";
    EventType["RouteOptimizationCanceled"] = "route:optimization:canceled";
    EventType["RouteOptimizationPolling"] = "route:optimization:polling";
    EventType["RouteOptimizationDone"] = "route:optimization:done";
    EventType["RouteOptimizationApplied"] = "route:optimization:applied";
    EventType["PlanningDone"] = "planning:done";
    EventType["InventoryScheduledArrivalCreated"] = "inventory:scheduled_arrival:created";
    EventType["Scanned"] = "scanned";
    EventType["InventoryScanned"] = "inventory_scanned";
    EventType["AlertCreated"] = "alert_created";
    EventType["RunStarted"] = "run:started";
    EventType["RunEnded"] = "run:ended";
    EventType["RunDeleted"] = "run:deleted";
    EventType["RunTaskAdded"] = "run:task:added";
    EventType["RunTaskRemoved"] = "run:task:removed";
    EventType["RunUpdated"] = "run:updated";
    EventType["RunCreated"] = "run:created";
    EventType["RunSendUpdateWebhook"] = "run:send_update_webhook";
    EventType["RunCalculateAggregations"] = "run:calculate_aggregations";
    EventType["InvoiceCreated"] = "invoice:created";
    EventType["RunDebriefed"] = "run:debriefed";
    EventType["TasksMassRemove"] = "tasks:mass_remove";
    EventType["ManifestDone"] = "manifest:done";
    EventType["LocationHistoryReceived"] = "location_history_received";
    EventType["QuoteReceived"] = "quote_received";
    EventType["DeliveryBlockAssigned"] = "delivery_block:assigned";
    EventType["DeliveryBlockUnassigned"] = "delivery_block:unassigned";
    EventType["DeliveryBlockCreated"] = "delivery_block:created";
    EventType["DeliveryBlockUpdated"] = "delivery_block:updated";
    EventType["DeliveryBlockDeleted"] = "delivery_block:deleted";
    EventType["DriverShiftScheduleUpdated"] = "driver_shift_schedule:updated";
    EventType["SchedulerEvent"] = "scheduler_event";
    EventType["MobileAnalyticsEvent"] = "mobile_analytics_event";
    EventType["MenuUpdated"] = "menu:updated";
    EventType["TaskInventoryUpdate"] = "task_inventory:update";
    EventType["MobileActionEvent"] = "mobile_action_event";
    EventType["WayPointAnswersCreated"] = "way_point:answers:created";
    EventType["WayPointScheduledArrivalUpdated"] = "way_point:scheduled_arrival:updated";
    EventType["MaskedPhoneCallFinished"] = "masked_phone:call_finished";
    EventType["RapidSosRequested"] = "rapid_sos_requested";
    EventType["RatingSubmitted"] = "rating:submitted";
    EventType["UserActualBreakUpdated"] = "user:actual_break:updated";
    EventType["TimeBasedEvent"] = "time_based_event";
    EventType["OpenFleetIntegrationEvent"] = "open_fleet:integration_event";
    EventType["WorkflowTimeBasedEvent"] = "workflow:time_based_event";
    EventType["WorkflowManual"] = "workflow:manual";
    EventType["WorkflowProcessNextChunk"] = "workflow:process_next_chunk";
    EventType["VrpAutoDispatchFailed"] = "vrp_auto_dispatch_failed";
    EventType["PackageCreated"] = "package:created";
    EventType["PackageUpdated"] = "package:updated";
    EventType["PackageDeleted"] = "package:deleted";
    EventType["FleetDeliveryActionCreateFailed"] = "fleet_delivery_action:create:failed";
    EventType["FleetAssigned"] = "fleet:assigned";
    EventType["NoFleetFound"] = "fleet_router:no_fleet_found";
    EventType["SmsSendFailed"] = "sms:send:failed";
    EventType["TaskAcceptedByExternalFleet"] = "task:accepted_by_external_fleet";
    EventType["GroupTaskCalculateAggregations"] = "group_task:calculate_aggregations";
    EventType["DriverUnavailabilityChange"] = "user:unavailability_change";
    EventType["TaskReassignReasonCreated"] = "task_reassign_reason:created";
    EventType["WayPointCalculateServiceAreas"] = "way_point:calculate_service_areas";
    EventType["DeliveryWindowCreated"] = "delivery_window:created";
    EventType["DeliveryWindowUpdated"] = "delivery_window:updated";
    EventType["DeliveryWindowDeleted"] = "delivery_window:deleted";
    EventType["PlannedDeliveryWindowUpdated"] = "planned_delivery_window:updated";
    EventType["ExclusionWindowCreated"] = "exclusion_window:created";
    EventType["ExclusionWindowUpdated"] = "exclusion_window:updated";
    EventType["UnassignedAvailabilityTasks"] = "unassigned_availability_tasks";
    EventType["DeliveryProviderOfferingCreated"] = "delivery_provider_offering:created";
    EventType["DeliveryProviderOfferingUpdated"] = "delivery_provider_offering:updated";
    EventType["RecurringTemplateTimesReassigned"] = "recurring_template:times_reassigned";
    EventType["CustomWorkflowWebhookTaskEvent"] = "custom_workflow:webhook:task";
    EventType["CustomWorkflowWebhookTasksEvent"] = "custom_workflow:webhook:tasks";
    EventType["FeetStatusUpdate"] = "fleet:status:update";
    EventType["CustomWorkflowWebhookUserEvent"] = "custom_workflow:webhook:user";
    EventType["DeliveryWindowFillRatioChanged"] = "delivery_window_fill_ratio_changed";
    EventType["CustomWorkflowWebhookDeliveryWindowEvent"] = "custom_workflow:webhook:delivery_window";
})(EventType || (exports.EventType = EventType = {}));
var AvailabilityCalculationOrigin;
(function (AvailabilityCalculationOrigin) {
    AvailabilityCalculationOrigin["QUOTE_ORDERS"] = "QUOTE_ORDERS";
    AvailabilityCalculationOrigin["AUTOMATION_PLATFORM"] = "AUTOMATION_PLATFORM";
})(AvailabilityCalculationOrigin || (exports.AvailabilityCalculationOrigin = AvailabilityCalculationOrigin = {}));
//# sourceMappingURL=event.js.map